import type { ReactNode } from 'react';

interface StatCardProps {
  label: string;
  value: ReactNode;
  icon: ReactNode;
  tone?: 'brand' | 'success' | 'warning' | 'danger' | 'info' | 'neutral';
}

const toneClass = {
  brand: 'bg-brand-50 text-brand',
  success: 'bg-success-soft text-success',
  warning: 'bg-warning-soft text-warning-text',
  danger: 'bg-danger-soft text-danger',
  info: 'bg-info-soft text-info',
  neutral: 'bg-surface-2 text-ink-700',
};

export function StatCard({ label, value, icon, tone = 'brand' }: StatCardProps) {
  return (
    <div className="stat-card">
      <div className={`stat-icon ${toneClass[tone]}`}>{icon}</div>
      <div className="min-w-0">
        <p className="stat-label">{label}</p>
        <p className="stat-value truncate">{value}</p>
      </div>
    </div>
  );
}
